export default __webpack_public_path__ + "bb64f7cb854cb15e448b4d3c0b3d08a3.jpg";